// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import VueRouter from 'vue-router'
import store from './store';
import router from './router';
import VueClipboard from 'vue-clipboard2';
let clipboard = Vue.use(VueClipboard);
Vue.config.productionTip = false;


import { getFetch, postFetchBody, postFetchParams, } from './utils/getData'
import Base from './assets/js/baseLocal.js'        //---------自定义的公共函数和公共请求方法
import API from './api/api'
import util from './utils/util'
import jQuery from 'jquery'

import './oauth'
// import './back'
// import './mock/index';            // 该项目所有请求使用mockjs模拟
import './config/vue-prototype'


//日志打印代码
// import VConsole from 'vconsole';
// const vConsole = new VConsole();

// import mint from 'mint-ui';
//引用部分mint-ui组件
import 'mint-ui/lib/style.css'
import { Button, Navbar, TabItem, InfiniteScroll, TabContainer, TabContainerItem, Loadmore, Spinner, Popup } from 'mint-ui';
Vue.component(Button.name, Button);
Vue.component(Navbar.name, Navbar);
Vue.component(TabItem.name, TabItem);
Vue.component(Popup.name, Popup);
Vue.use(InfiniteScroll);
Vue.component(TabContainer.name, TabContainer);
Vue.component(TabContainerItem.name, TabContainerItem);
Vue.component(Loadmore.name, Loadmore);
Vue.component(Spinner.name, Spinner);

//注册全局函数和全局常量
Vue.prototype.$ = jQuery;
Vue.prototype.$getFetch = getFetch;
Vue.prototype.$postFetchBody = postFetchBody;
Vue.prototype.$postFetchParams = postFetchParams;
Vue.prototype.$api = API;
Vue.prototype.$util = util;
Vue.prototype.$baseUrl = process.env.OSS_URI + '/';
Vue.prototype.$baseLocal = Base.baseLocal;
Vue.prototype.$store = store;

import 'lib-flexible/flexible'  // 引入 px2rem

import VueWechatTitle from 'vue-wechat-title'
Vue.use(VueWechatTitle)
Vue.use(VueRouter);
new Vue({
  el: '#app',
  router,                 //-----router文件
  store,                  //-----全局变量
  template: '<App/>',
  components: { App }
}).$mount('#app');



// WEBPACK FOOTER //
// ./src/main.js